import { v4 as uuidV4 } from 'uuid';
import { useCallback } from 'react';
import { useSiteConfig } from '../../config/site-config/useSiteConfig';
import { useApiBase } from '../../query/useApiBase';

const win = window as any;
const tempSessionId = uuidV4();

export function useTransformUsername() {
  const { environment, siteCode } = useSiteConfig();
  const getBaseUrl = useApiBase();
  const ddSessionId = win.DD_RUM?.getInternalContext()?.session_id;

  return useCallback(
    async (username: string) => {
      const route = `/account-management/v1/users/transform-username/${username}`;
      const apiBase = getBaseUrl(route);
      const url = `${apiBase}${route}`;
      try {
        const response = await fetch(url, {
          headers: {
            'IM-CorrelationID': uuidV4(),
            'IM-DDSessionId': ddSessionId || tempSessionId,
            'IM-Environment': environment,
            'IM-SenderID': 'IMCEP',
            'IM-SiteCode': siteCode,
          },
          method: 'GET',
        });
        if (response) {
          const transformedUsername = await response.text();
          if (transformedUsername) {
            return transformedUsername;
          }
        }
        return username;
      } catch (e) {
        console.error('username transformation error: ', e);
        return username;
      }
    },
    [environment, siteCode, getBaseUrl, ddSessionId]
  );
}
